import { Agency } from '../types/masterData';

export const initialAgencies: Agency[] = [
  { id: 'somali-police', name: 'Somali Police Force', type: 'Police', status: 'Active' },
  { id: 'state-police', name: 'State Police', type: 'Police', status: 'Active' },
  { id: 'district-admin', name: 'District Administration', type: 'Government', status: 'Active' },
  { id: 'other-gov', name: 'Other Government Agency', type: 'Government', status: 'Active' },
  { id: 'nisa', name: 'National Intelligence and Security Agency', type: 'Security', status: 'Active' },
  { id: 'sna', name: 'Somali National Army', type: 'Security', status: 'Active' }
];
